module.exports = __webpack_public_path__ + "img/chips10000.eaf1bf47.png";